import { render } from "./FbnPublishingInfo.vue?vue&type=template&id=02161b96"
import script from "./FbnPublishingInfo.vue?vue&type=script&lang=js"
export * from "./FbnPublishingInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__